export function publicAssetPath(path: string): string {
 const cleanPath = path.replace(/^\/+/, '')
 const publicUrl = process.env.PUBLIC_URL ?? ''

 if (!publicUrl || publicUrl === '/') {
 return `/${cleanPath}`
 }

 if (publicUrl === '.' || publicUrl === './') {
 return `./${cleanPath}`
 }

 return `${publicUrl.replace(/\/$/, '')}/${cleanPath}`
}

